
const Name = (cell) => {
    return cell.value ? cell.value : '';
};
const Name_en = (cell) => {
  return cell.value ? cell.value : '';
};
const Name_fr = (cell) => {
    return cell.value ? cell.value : '';
};

const Name_ar = (cell) => {
  return cell.value ? cell.value : '';
};
const Description_ar = (cell) => {
  return cell.value ? cell.value : '';
};
const Description_en = (cell) => {
  return cell.value ? cell.value : '';
};
const Description_fr = (cell) => {
  return cell.value ? cell.value : '';
};
const Is_vendor = (cell) => {
  return cell.value ? cell.value : '';
};
const IsActive = cell => {
  return cell.value ? cell.value : ""
}



export { Name_ar, Name_en, Name, Name_fr,Description_fr,Description_en,Description_ar, IsActive,Is_vendor }